export default "__VITE_ASSET__3bd7d317__"